import { collectionGroup, getDocs, doc, getDoc } from "firebase/firestore";
import { firestore as db } from "../../../../backend/firebaseconfig"; // Adjust path as needed
import dayjs from "dayjs";

/**
 * Fetch ALL Cashflow Modeller clients across all roles for CFM Admin.
 * For each client, it includes:
 *   - Client ID
 *   - Client name (first 2 names joined)
 *   - Creation date
 *   - CreatedBy (email)
 *   - Trading name
 *   - Primary color
 *
 * @returns {Promise<Array>} Array of enriched client objects.
 */
export const getAllCashflowClientsForAdmin = async () => {
  const snapshot = await getDocs(collectionGroup(db, "Cashflow Modeller"));
  //   console.log("Number of CFM docs found:", snapshot.size);

  const enrichedClients = await Promise.all(
    snapshot.docs.map(async (cfmDoc) => {
      const path = cfmDoc.ref.path;
      const segments = path.split("/");
      //   console.log("Full path:", path, "Segments:", segments);

      // Adjust indices based on your actual structure!
      const role = segments[1];
      const email = segments[3];

      //   console.log(`Parsed => role: ${role}, email: ${email}`);

      const parentRef = doc(db, "Authorized Members", role, "Data", email);
      const parentSnap = await getDoc(parentRef);
      const parentData = parentSnap.exists() ? parentSnap.data() : {};

      const cfmData = cfmDoc.data();
      const cfmId = cfmDoc.id;

      return {
        id: cfmId,
        role,
        name:
          cfmData.details && Array.isArray(cfmData.details)
            ? cfmData.details
                .slice(0, 2)
                .map((d) => d.name)
                .filter(Boolean)
                .join(" & ") || "Unnamed Client"
            : "Unnamed Client",
        rawDate: cfmData.createdAt || null,
        date: cfmData.createdAt
          ? dayjs(cfmData.createdAt).format("DD/MM/YYYY")
          : "Unknown",
        updatedOn: cfmData.updatedOn
          ? dayjs(cfmData.updatedOn).format("DD/MM/YYYY")
          : "Unknown",
        createdBy: email,
        tradingName:
          parentData.tradingName || "Rosemount Financial Solutions (IFA) Ltd",
        primaryColor: parentData.primaryColor || "081e56",
        regulatoryText:
          parentData.regulatoryText ||
          "Rosemount Financial Solutions (IFA) Ltd is authorised and regulated by the Financial Conduct Authority (FCA). Entered on the FCA Register (https://register.fca.org.uk/) under reference 535515. Rosemount Financial Solutions (IFA) Ltd is registered in England and Wales, Registered No. 05668905, Registered Address Rosemount House, 2 – 4 Chequers Road, Basingstoke, RG21 7PU.",
        // ---- flags for dashboard filtering ----
        isScenario: !!cfmData?.isScenario, // could be boolean or missing       parentDocId: cfmData?.parentDocId || "",         // empty string if not present
        // keep scenarios light: only ids (and name if you want to show it)
        scenarios: Array.isArray(cfmData?.scenarios)
          ? cfmData.scenarios
              .map((s) => ({ id: s?.id, name: s?.name }))
              .filter((s) => !!s.id)
          : [],
      };
    })
  );

  // console.log("Enriched clients:", enrichedClients.length );

  return enrichedClients.sort((a, b) => {
    const dateA = a.rawDate ? new Date(a.rawDate).getTime() : 0;
    const dateB = b.rawDate ? new Date(b.rawDate).getTime() : 0;
    return dateB - dateA;
  });
};
